import React, { useState } from "react";
import { Grid } from "@mui/material";

import { useTranslation } from "react-i18next";
import Survey from "./Survey";
import Completed from "./Completed";
import HeaderImage from "../components/HeaderImage";
import Header from "../components/Header";
import { SURVEY_IDS } from "../utils/constants";

const Etech = (props) => {
  const [isCompleted, setIsCompleted] = useState(false);
  const { t } = useTranslation();
  {
    document.title = " RENAULT MEGANE E-TECH ";
  }

  const surveyId = SURVEY_IDS.MEGANE_E_TECH;
  return (
    <Grid container>
      <Header model={"meganeEtech"} />
      <HeaderImage model={"meganeEtech"} />

      {isCompleted ? <Completed /> : <Survey setIsCompleted={setIsCompleted} surveyId={surveyId} />}
    </Grid>
  );
};

export default Etech;
